<div class="w-full reschedule-job-dialog">
  <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
    <div class="flex items-center flex-1 overflow-hidden">
      <h6 mat-dialog-title class="font-semibold primary-font w-full truncate" [title]="dialogTitle">{{(type === 'RESCHEDULE' ? 'text.reschedule' : 'text.schedule') | translate}} - {{dialogTitle}}</h6>
    </div>
    <div class="flex items-center mr-1 min-w-fit flex-0">
      <span mat-dialog-close
        class="rounded-full cursor-pointer flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </span>
    </div>
  </div>
  <div class="flex flex-col zuper-dialog-body max-dialog-height overflow-y-auto zuper-scrollbar p-4">
    <div>
      <form [formGroup]="rescheduleJobForm" class="cancelForm h-full overflow-y-none" autocomplete="off">
        <!-- Job Time Section -->
        <div class="grid grid-cols-2 gap-x-4 mb-4">
          <!-- Job Start Time -->
          <div class="flex flex-col w-full">
            <div class="mb-2">
              <label class="block text-base font-medium text-gray-700 required cursor-pointer">
                {{'text.job_start_time' | translate}}
              </label>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field appearance="fill" class="w-full h-fit" [floatLabel]="'always'">
                <input matInput readonly class="cursor-pointer" (focus)="startDatePicker?.open()"
                  [matDatepicker]="startDatePicker" formControlName="startDate" [datePickerFormat]="dateFormat"
                  (dateChange)="onDateChange()" [min]="dateValidationRanges.minStartDate"
                  [max]="dateValidationRanges.maxStartDate" placeholder="{{'text.choose_date' | translate}}">
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full h-fit" [floatLabel]="'always'">
                <input matInput readonly class="cursor-pointer" placeholder="{{'text.pick_time' | translate}}"
                  formControlName="startTime" [matMenuTriggerFor]="startTimePicker" />
                <button mat-icon-button matSuffix [matMenuTriggerFor]="startTimePicker" [disabled]="rescheduleJobForm.controls.startDate.disabled">
                  <mat-icon [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                </button>
                <mat-menu #startTimePicker="matMenu">
                  <div class="flex flex-col">
                    <div class="flex justify-center">
                      <ngx-mat-timepicker (click)="$event.stopPropagation()" [disabled]="false" [showSpinners]="true"
                        [stepHour]="1" [stepMinute]="1" [showSeconds]="false" [enableMeridian]="isMeridian()"
                        formControlName="startTimePicker">
                      </ngx-mat-timepicker>
                    </div>
                    <div class="flex justify-center">
                      <button mat-stroked-button>
                        {{'text.ok' | translate}}
                      </button>
                    </div>
                  </div>
                </mat-menu>
              </mat-form-field>
            </div>
          </div>
          
          <!-- Job End Time -->
          <div class="flex flex-col w-full">
            <div class="mb-2">
              <label class="block text-base font-medium text-gray-700 required">
                {{'text.job_end_time' | translate}}
              </label>
            </div>
            <div class="grid grid-cols-2 gap-x-4">
              <mat-form-field appearance="fill" class="w-full h-fit" [floatLabel]="'always'">
                <input matInput readonly [min]="dateValidationRanges.minEndDate" [max]="dateValidationRanges.maxEndDate"
                  class="cursor-pointer" [matDatepicker]="endDatePicker" (focus)="endDatePicker?.open()"
                  formControlName="endDate" [datePickerFormat]="dateFormat" (dateChange)="onDateChange()"
                  placeholder="{{'text.choose_date' | translate}}">
                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="fill" class="w-full h-fit" [floatLabel]="'always'">
                <input matInput readonly placeholder="{{'text.pick_time' | translate}}" class="cursor-pointer"
                  [matMenuTriggerFor]="toMenu" formControlName="endTime" />
                <mat-error
                  *ngIf="rescheduleJobForm.controls.endTime.hasError('invalidEndTime')">
                  {{'dispatchBoard.scheduler.reschedule.start_end_time_invalid' | translate}}
                </mat-error>
                <button mat-icon-button matSuffix [matMenuTriggerFor]="toMenu" [disabled]="rescheduleJobForm.controls.endDate.disabled">
                  <mat-icon [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                </button>
                <mat-menu #toMenu="matMenu">
                  <div class="flex flex-col">
                    <div class="flex justify-center">
                      <ngx-mat-timepicker formControlName="endTimePicker" (click)="$event.stopPropagation()"
                        [disabled]="false" [showSpinners]="true" [stepHour]="1" [stepMinute]="1" [showSeconds]="false"
                        [enableMeridian]="isMeridian()">
                      </ngx-mat-timepicker>
                    </div>
                    <div class="flex justify-center">
                      <button mat-stroked-button>
                        {{'text.ok' | translate}}
                      </button>
                    </div>
                  </div>
                </mat-menu>
              </mat-form-field>
            </div>
          </div>
        </div>
        
        <!-- Warning Messages Section -->
        <div class="mb-4 text-base cursor-default text-red-500" *ngIf="!blockJobsOnHoliday">
          <div class="flex items-center" *ngIf="jobAlreadyInAnotherRoute?.show">
            <i class="ti ti-alert-triangle text-red-500 text-2xl mr-1"></i>
            <mat-error class="font-medium">{{jobAlreadyInAnotherRoute.msg}}</mat-error>
          </div>
            @if (warningsList?.routeDurationExceedWarning?.show) {
            <mat-error>{{warningsList?.routeDurationExceedWarning?.msg}}</mat-error>
            }
            @else {
              @if (warningsList?.dateWarnings?.show) {
                <mat-error>{{warningsList?.dateWarnings?.msg}}</mat-error>
              }
              @if (warningsList?.shiftHoursExceedWarning?.show) {
                <mat-error>{{warningsList?.shiftHoursExceedWarning?.msg}}</mat-error>
              }
              @if (warningsList?.routeJobScheduleConflictWarning?.show) {
                <mat-error>{{warningsList?.routeJobScheduleConflictWarning?.msg}}</mat-error>
              }
              @if (warningsList?.timeWarnings?.show) {
                <mat-error>{{warningsList?.timeWarnings?.msg}}</mat-error>
              }
              @if (warningsList?.dueDateWarning?.show) {
                <mat-error>{{warningsList?.dueDateWarning?.msg}}</mat-error>
              }
              @if (warningsList?.eventOverlapWarning?.show) {
                <mat-error>{{warningsList?.eventOverlapWarning?.msg}}</mat-error>
              }
              @if (warningsList?.nonJobEventOverlapWarning?.show) {
                <mat-error>{{warningsList?.nonJobEventOverlapWarning?.msg}}</mat-error>
              }
              @if (showClearScheduleAlert) {
                <mat-error>{{'reschedule.clear_schedule.error.message' | translate}}</mat-error>
              }
            }
        </div>
        
        <!-- Holiday Warning Section -->
        <div class="flex items-center space-x-4 py-4 mb-4" *ngIf="blockJobsOnHoliday">
          <i class="ti ti-alert-triangle text-red-500 text-3xl cursor-default"></i>
          <span class="text-red-500 font-medium text-base cursor-default">
            {{'dispatchBoard.scheduler.error.block_new_job_on_holiday' | translate}} : {{blockHolidayName}}
          </span>
        </div>
        
        <!-- Reason Section -->
        <div class="w-full mb-4" *ngIf="!blockJobsOnHoliday">
          <label for="reason" class="block text-base font-medium mb-2 text-gray-700">
            {{'reason.for.update.job.schedule' | translate}}
          </label>
          <textarea
            class="w-full max-h-52 min-h-32 overflow-y-auto zuper-scrollbar border border-gray-300 rounded-md p-4"
            formControlName="reason" cols="40">
          </textarea>
        </div>

        <!-- Manage User Assignment Section -->
        @if (!blockHolidayName && isMultiTechAssignmentEnabled) {
          <div class="w-full my-4" #manageUserAssignmentContainer>
            <div class="flex justify-between items-center mb-4">
              @if (manageUserAssignment?.allUsers?.length) {
                <span class="text-base font-medium text-gray-700">{{'text.assign_from' | translate}} '{{teamName}}'</span>
              }
              @if (manageUserAssignment?.defaultUsers?.length && !manageUserAssignment?.allUsers?.length) {
                <span class="text-base font-medium text-gray-700">{{'header.job_assignment' | translate}}</span>
              }
              @if (manageUserAssignment?.showAllTeamUsers) {
                <div class="flex text-base font-normal text-gray-700">
                  <button class="px-4 py-2 hover:bg-gray-200 font-medium text-gray-700 rounded-md flex items-center" (click)="selectAllUsers(users)">
                    <span>{{'text.select_all' | translate}}</span>
                  </button>
                  <button class="px-4 py-2 hover:bg-gray-200 font-medium text-gray-700 rounded-md flex items-center" (click)="unSelectAllUsers(users)">
                    <span>{{'text.deselect.all' | translate}}</span>
                  </button>
                </div>
              }
            </div>
            <div class="flex flex-wrap gap-4 w-full">
              <ng-container *ngTemplateOutlet="userDetailsView; context: {users: manageUserAssignment?.defaultUsers, type:'default'}"></ng-container>
              @if (!manageUserAssignment?.showAllTeamUsers && manageUserAssignment?.allUsers?.length > 0) {
                <button class="flex space-x-4 items-center w-72" (click)="showAllTeamUsers()">
                  <div class="h-12 w-12 flex-shrink-0 flex items-center justify-center rounded-md bg-gray-300 text-2xl font-normal text-gray-700">
                    <i class="ti ti-users-plus text-2xl"></i>
                  </div>
                  <div class="flex flex-col items-start w-full overflow-hidden">
                    <span class="text-gray-600 truncate w-full text-left font-medium">{{'assign.more.text' | translate}}</span>
                    <span class="text-gray-500 truncate w-full text-left" title="{{teamName}}">{{teamName || ''}}</span>
                  </div>
                </button>
              }
              @else {
                <ng-container *ngTemplateOutlet="userDetailsView; context: {users: manageUserAssignment?.allUsers, type:'all'}"></ng-container>
              }
            </div>
          </div>
        }
      </form>
    </div>
  </div>

  <div class="flex border-t border-gray-300 zuper-dialog-footer p-4">
    <div *ngIf="type === 'RESCHEDULE' && enableClearSchedule">
      <button class="px-4 text-base" mat-button (click)="clearSchedule()">
        <span class="cursor-pointer text-primary">{{'text.clear_schedule' | translate}}</span>
      </button>
    </div>
    <div class="flex ml-auto space-x-4">
      <button type="button" mat-stroked-button mat-dialog-close (click)="cleanUp()"
        class="px-6 btn-small items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
        {{'cancel.text' | translate}}</button>
      <button [disabled]="validatingOverlapsAndTimeoff || disableUpdateBtn || isOperationInProgress"
        class="flex min-w-24 btn-small px-6 items-center py-2 border text-base b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary"
        [ngClass]="{'opacity-30 cursor-not-allowed submitBtn default-hover': disableUpdateBtn}"
        (click)="rescheduleJob()">
        <mat-spinner [diameter]="30" *ngIf="validatingOverlapsAndTimeoff || isOperationInProgress" class="mr-2"></mat-spinner>
        <span class="text-white">{{'update' | translate}}</span>
      </button>
    </div>
  </div>
</div>

<ng-template #userDetailsView let-users="users" let-type="type">
  @for (user of users; track user?.user_uid) {
    <div class="rounded-lg transition-colors w-72 h-20 group" id="user-details-container"
      [ngClass]="{
        'hover:bg-gray-50': (type !== 'default' && !user?.anotherTeam && !user?.isSelected),
        'bg-blue-50': user?.isSelected,
        'bg-gray-50': user?.infoOpend && !user?.isSelected && !user?.anotherTeam
      }">
      <label class="flex items-center gap-4 p-4 select-none w-full" [ngClass]="type === 'default' || user?.anotherTeam ? 'cursor-default' : 'cursor-pointer'">
        @if (user?.showCheckbox) {
          <div class="flex-shrink-0">
            <input type="checkbox" class="h-5 w-5 transition-all duration-200 ease-in-out" 
              [ngClass]="user?.anotherTeam ? 'cursor-default': 'cursor-pointer'"
              [checked]="user?.isSelected || user?.anotherTeam" 
              (change)="user.isSelected = $event.target.checked; onSelectedUserUpdated();"
              [disabled]="user?.anotherTeam"/>
          </div>
        }
        <div class="flex-shrink-0 relative">
          @if (user?.hasValidProfilePicture) {
            <div class="h-12 w-12 absolute inset-0 bg-gray-200 rounded-md animate-pulse"></div>
            
            <img class="h-12 w-12 rounded-md object-cover relative z-10" src="{{user?.profile_picture}}" alt="{{user?.name}}"
              title="{{user?.name}}" (load)="$event.target.previousElementSibling.style.display = 'none'" />
          }
          @else {
            <div class="h-12 w-12 items-center justify-center flex uppercase rounded-md bg-gray-300 text-2xl font-normal text-gray-700"
            title="{{user?.name}}">
              <span>{{user?.name[0]}}</span>
            </div>
          }
          @if (type == 'default') {
            <div class="flex-shrink-0 absolute -right-2 -bottom-[8px] z-10">
              @if (user?.type === 'assign') {
                <div class="bg-green-100 icon-size-5 flex items-center justify-center ring-2 shadow-md ring-white rounded-full">
                  <i class="ti ti-user-check cursor-default text-2xl text-green-600"></i>
                </div>
              }
              @else {
                @if (user?.type === 'unassign') {
                  <div class="bg-red-100 icon-size-5 flex items-center justify-center ring-2 shadow-md ring-white rounded-full">
                    <i class="ti ti-user-minus cursor-default text-2xl text-red-600"></i>
                  </div>
                }
              }
            </div>
          }
        </div>
        <div class="flex primary-font flex-col text-base text-gray-700 min-w-0 flex-1">
          <div class="flex items-center justify-between">
            <span class="font-medium text-base truncate">{{user?.name}}</span>
            <div class="opacity-0 transition-opacity w-5 h-5 flex items-center justify-center" [ngClass]="{
                'opacity-100': user?.infoOpend,
                'group-hover:opacity-100 group-focus:opacity-100': !user?.infoOpend
              }" (click)="$event.stopPropagation(); $event.preventDefault(); openUserInfo($event, user)">
              <i class="ti ti-info-circle text-2xl"></i>
            </div>

          </div>
          @if (user?.role?.role_name) {
            <span class="text-gray-500 truncate" title="{{user?.role?.role_name}}">{{user?.role?.role_name}}</span>
          }
          @if (user?.anotherTeam) {
            <span class="text-gray-400 truncate" title="{{'text.assigned_from' | translate}} {{user?.anotherTeam?.team_name}}">{{user?.anotherTeam?.team_name}}</span>
          }
        </div>
      </label>
    </div>
  }
</ng-template>

<ng-template #userInfoContent let-user="user" let-toggleTab="toggleTab" let-activeTab="activeTab">
  <div class="bg-white rounded shadow-md p-3 max-w-xs w-full" 
       [ngClass]="(user?.skillDetails?.matchedSkills?.length || user?.skillDetails?.unmatchedSkills?.length || user?.shiftDetails?.length) ? 'min-w-[265px]' : 'min-w-[200px]'">
    <div class="flex border-b border-gray-100 mb-2">
      <button 
        class="font-medium text-base primary-font flex items-center" 
        [ngClass]="{
          'border-blue-500 text-blue-600': activeTab === 'skills' && user?.shiftDetails,
          'border-transparent text-gray-500': activeTab !== 'skills' && user?.shiftDetails,
          'border-b-2 py-1.5 px-3': user?.shiftDetails,
          'text-gray-700 flex justify-between pb-1 w-full': !user?.shiftDetails
        }"
        (click)="toggleTab('skills')">
        <span>{{'text.skills' | translate}}</span>
        <span class="bg-blue-50 text-blue-600 text-base px-2 py-0.5 rounded-full font-medium primary-font ml-1.5">
          {{user?.skillDetails?.validSkillCount}}/{{user?.skillDetails?.jobSkillCount}}
        </span>
      </button>
      @if (user?.shiftDetails) {
        <button 
          class="py-1.5 px-3 font-medium text-base primary-font border-b-2 flex items-center" 
          [ngClass]="activeTab === 'shifts' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500'"
          (click)="toggleTab('shifts')">
          <span>{{'shifts.label' | translate}}</span>
          <span class="ml-1.5 bg-green-50 text-green-600 text-base px-2 py-0.5 rounded-full font-medium primary-font">
        {{user?.shiftDetails?.length || 0}}
          </span>
        </button>
      }
    </div>

    <!-- Skills Content -->
    @if (activeTab === 'skills') {
      <div class="flex flex-col max-h-[250px] overflow-y-auto zuper-scrollbar">
        @if (user?.skillDetails?.matchedSkills?.length || user?.skillDetails?.unmatchedSkills?.length) {
          <div class="space-y-1 primary-font">
            <!-- Matched Skills -->
            @for (skillDetails of user?.skillDetails?.matchedSkills || [] ; track skillDetails?.skillUid) {
            <div class="flex flex-col py-1">
              <div class="flex items-center justify-between">
                <div class="flex items-center flex-1 overflow-hidden">
                  <i class="ti ti-circle-check text-green-500 mr-1.5 flex-shrink-0 text-2xl"></i>
                  <span class="text-base font-medium text-gray-700 truncate" title="{{skillDetails?.skillName}}">{{skillDetails?.skillName}}</span>
                </div>
                @if (skillDetails?.skill_level) {
                  <span class="text-base bg-green-100 text-green-600 px-1.5 rounded-full flex-shrink-0 font-normal">
                    {{skillDetails?.skill_level}}%
                  </span>
                }
              </div>
              @if (skillDetails?.isNearExpiration) {
                <div class="ml-7 text-md text-amber-500 font-normal flex-shrink-0">
                  {{'text.expires_on' | translate}} {{skillDetails?.expiredOn}}
                </div>
              }
            </div>
            }
            <!-- Unmatched Skills -->    
            @for (skillDetails of user?.skillDetails?.unmatchedSkills || [] ; track skillDetails?.skillUid) {
              <div class="flex flex-col py-1">
                <div class="flex items-center justify-between">
                  <div class="flex items-center flex-1 overflow-hidden">
                    <i class="ti ti-circle-x text-gray-400 mr-1.5 flex-shrink-0 text-2xl"></i>
                    <div class="flex items-center min-w-0">
                      <span class="text-base font-normal text-gray-500 truncate" title="{{skillDetails?.skillName}}">
                        {{skillDetails?.skillName}}
                      </span>
                    </div>
                  </div>
                  @if (skillDetails?.skill_level) {
                    <span class="text-base bg-gray-100 text-gray-500 px-1.5 rounded-full flex-shrink-0 font-normal">
                      {{skillDetails?.skill_level}}%
                    </span>
                  }
                </div>
                @if (skillDetails?.isExpired) {
                  <div class="ml-7 text-md text-red-500 font-normal flex-shrink-0 flex items-center gap-1">
                    <i class="ti ti-clock-x text-base text-red-500"></i>
                    <span>{{'expired' | translate}}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
        @else {
          <div class="text-base font-medium text-gray-600 mb-2 primary-font">{{'sidebar.data.skills.placeholder' | translate}}</div>
        }
      </div>
    }

    <!-- Shifts Content -->
    @if (activeTab === 'shifts' && user?.shiftDetails) {
      <div class="flex flex-col max-h-[250px] overflow-y-auto zuper-scrollbar">
      @if (user?.shiftDetails?.length) {
        <div class="space-y-1 primary-font">
        @for (shift of user?.shiftDetails || [] ; track shift?.shiftId) {
          <div class="flex flex-col py-1">
          <div class="flex items-center justify-between">
            <div class="flex items-center flex-1 overflow-hidden">
            <i class="ti ti-clock text-green-500 mr-2 flex-shrink-0 text-2xl mt-0.5"></i>
            <span class="text-base font-medium text-gray-700 truncate" title="{{shift?.shiftName}}">{{shift?.shiftName}}</span>
            </div>
          </div>
          <!-- Shift Time -->
          <div class="ml-7 text-md text-gray-600 font-normal flex-shrink-0 truncate">
            {{shift?.startDateTime}} - {{shift?.endDateTime}}
          </div>
          </div>
        }
        </div>
      }
      @else {
        <div class="text-base font-medium text-gray-600 mb-2 primary-font">{{'job.details.no_shift_available' | translate}}</div>
      }
      </div>
    }
  </div>
</ng-template>